goog.provide("shadow.js.shim.module$$mui$material$StepLabel");
goog.provide("module$shadow_js_shim_module$$mui$material$StepLabel");
shadow.js.shim.module$$mui$material$StepLabel = shadow.js.nativeProvides["@mui/material/StepLabel"] = shadow$bridge("@mui/material/StepLabel");
module$shadow_js_shim_module$$mui$material$StepLabel.default = shadow.js.shim.module$$mui$material$StepLabel;
